/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Item para mostrar un estado y su cantidad de ofertas
 * @export
 * @interface CandidateCountOfferPerState
 */
export interface CandidateCountOfferPerState {
    /**
     * 
     * @type {number}
     * @memberof CandidateCountOfferPerState
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof CandidateCountOfferPerState
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof CandidateCountOfferPerState
     */
    count?: number;
}

export function CandidateCountOfferPerStateFromJSON(json: any): CandidateCountOfferPerState {
    return CandidateCountOfferPerStateFromJSONTyped(json, false);
}

export function CandidateCountOfferPerStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateCountOfferPerState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function CandidateCountOfferPerStateToJSON(value?: CandidateCountOfferPerState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'count': value.count,
    };
}


